import store from "../../../store";
import base_delivery from "./base_delivery.vue";

window.DELIVERY_GO =  new Vue({
    store,
    el: 'div#delivery_block',
    name : "DELIVERY_BLOCK",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        base_delivery
    }
});
